<script setup lang="ts">
import EditDsApiTokenVODrawer from '@/pages/erp/ds/token/view/ds-apiToken-drawer.vue'
import type { DsApiTokenVOProperties } from '@/pages/erp/ds/token/db/ds-apiToken-types'
import Swal from 'sweetalert2'
definePage({
    meta: {
        action: 'manage',
        subject: 'DSAPITOKEN',
    },
})

const appId = ref()
const appDesc = ref()

// Data table options
const currentPage = ref(1)
const size = ref(10)
const sortOrder = ref()
const orderByCol = ref()

// Update data table options
const updateOptions = (options: any) => {
  sortOrder.value = options.sortBy[0]?.key
  orderByCol.value = options.sortBy[0]?.order
}

// Headers

const grid1Headers = [
    { title: '平台ID', key: 'appId' },
    { title: '平台名稱', key: 'appDesc' },
    { title: 'owner', key: 'owner' },
    { title: '平台狀態', key: 'state' },
    { title: '操作', key: 'actions', sortable: false}
]


// champ 後端分頁是從 0 開始
const page = computed((): number => currentPage.value - 1)

// 👉 Fetching users
const { data: dsApiTokenVOsData, execute: fetchDsApiTokenVOs } = await useApi<any>(createUrl('/ds/token/apiToken/searchDsApiTokenVO', {
  query: {
    appId,
    appDesc,
    page,
    size,
    orderByCol,
    sortOrder,
  },
}))

const datas = computed((): DsApiTokenVOProperties[] => dsApiTokenVOsData.value.data.dsApiTokenVOPage.content)
const totalDatas = computed(() => dsApiTokenVOsData.value.data.dsApiTokenVOPage.totalElements)

console.log('datas: ', datas)

const isEditDataDrawerVisible = ref(false)
const isNewData = ref(false)
const isCopyData = ref(false)

let voData = {}


const createData = () => {
  isEditDataDrawerVisible.value = true
  isNewData.value = true
  isCopyData.value = false
}

const editData = (dsApiTokenVOData: DsApiTokenVOProperties) => {
  voData = dsApiTokenVOData
  console.log('editDsApiTokenVO: ', voData)
  isEditDataDrawerVisible.value = true
  isNewData.value = false
  isCopyData.value = false
}

const copyData = (dsApiTokenVOData: DsApiTokenVOProperties) => {
    voData = dsApiTokenVOData
    console.log('copyDsApiTokenVO: ', voData)
    isEditDataDrawerVisible.value = true
    isNewData.value = true
    isCopyData.value = true
}

// 👉 Add new data
const addNewData = async (dsApiTokenVOData: DsApiTokenVOProperties) => {
  await $api('/ds/token/apiToken/createDsApiTokenVO', {
    method: 'POST',
    body: { dsApiTokenVO: dsApiTokenVOData },
  }).then(() => {
      $swal({
      position: 'top-end',
      icon: 'success',
      title: '新增成功',
      showConfirmButton: false,
      timer: 1500,
      customClass: {
        confirmButton: 'btn btn-primary',
      },
      buttonsStyling: false,
    })
  })

  // refetch data
  fetchDsApiTokenVOs()
}

const updateData = async (dsApiTokenVOData: DsApiTokenVOProperties) => {
  await $api('/ds/token/apiToken/updateDsApiTokenVO', {
    method: 'PUT',
    body: { dsApiTokenVO: dsApiTokenVOData },
  }).then(() => {
      $swal({
      position: 'top-end',
      icon: 'success',
      title: '修改成功',
      showConfirmButton: false,
      timer: 1500,
      customClass: {
        confirmButton: 'btn btn-primary',
      },
      buttonsStyling: false,
    })
  })

  // refetch data
  fetchDsApiTokenVOs()
}

  // 👉 Delete data
const deleteData = async (dsApiTokenVOData: DsApiTokenVOProperties) => {
  const { appId } = dsApiTokenVOData
    $swal({
    title: `確定要刪除 ${dsApiTokenVOData.appId} 資料?`,
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "確定",
    cancelButtonText: "取消"
  }).then((result) => {
    if (result.isConfirmed) {
        $api(`/ds/token/apiToken/deleteDsApiTokenVO`, {
        method: 'DELETE',
        query: {
          appId
        }
      }).then(() => {
          $swal({
          position: 'top-end',
          title: "刪除成功",
          timer: 1500,
          icon: "success"
        });

        // refetch Data
        fetchDsApiTokenVOs()
      })
    }
  });

}

const clickRow = (event, select) => {
  console.log('clickRow: ', event, select)
  editData(select.item)
}

</script>

<template>
  <!-- 👉 Widgets -->

  <VCard class="mb-6">
    <VCardItem class="pb-2 pt-2">
      <VCardTitle>搜尋</VCardTitle>
    </VCardItem>

    <VCardText>
      <VRow> 
        <VCol
         cols="12"
         sm="2"
        >
          <AppTextField
            v-model="appId"
            clearable
            clear-icon="mdi-close-circle"
            placeholder="請輸入平台ID"
          />
        </VCol>
        <VCol
         cols="12"
         sm="2"
        >
          <AppTextField
            v-model="appDesc"
            clearable
            clear-icon="mdi-close-circle"
            placeholder="請輸入平台名稱"
          />
        </VCol>
      </VRow>
    </VCardText>

    <VDivider />

    <VCardText class="d-flex flex-wrap gap-4">
      <VSpacer />

      <div class="app-user-search-filter d-flex align-center flex-wrap gap-4">
        <!-- 👉 Add button -->
        <VBtn
                prepend-icon="tabler-plus"
                @click="createData"
        >
          新增API Token 管理作業
        </VBtn>
      </div>
    </VCardText>

    <VDivider />

    <!-- SECTION datatable -->
    <VDataTableServer
            v-model:items-per-page="size"
            v-model:page="currentPage"
            :items="datas"
            :items-length="totalDatas"
            :headers="grid1Headers"
            class="text-no-wrap"
            @update:options="updateOptions"
    >
      
      <template #item.appId="{ item }">
          <div class="text-body-1 text-high-emphasis">
              {{ item.appId }}
          </div>
      </template>
      
      <template #item.appDesc="{ item }">
          <div class="text-body-1 text-high-emphasis">
              {{ item.appDesc }}
          </div>
      </template>
      
      <template #item.owner="{ item }">
          <div class="text-body-1 text-high-emphasis text-capitalize">
              <div class="font-weight-medium ">
                  {{ toCode(item.owner) }}
              </div>
              <div class="text-sm">
                  {{ toText(item.owner) }}
              </div>
          </div>
      </template>
      
      <template #item.state="{ item }">
          <div class="text-body-1 text-high-emphasis">
              {{ item.state }}
          </div>
      </template>
      
      <!-- Actions -->
      <template #item.actions="{ item }">
          <IconBtn @click="editData(item)">
              <VIcon icon="tabler-edit" />
              <v-tooltip
                      activator="parent"
                      location="bottom"
              >編輯</v-tooltip>
          </IconBtn>
          <IconBtn @click="copyData(item)">
              <VIcon icon="tabler-copy" />
              <v-tooltip
                      activator="parent"
                      location="bottom"
              >複製</v-tooltip>
          </IconBtn>
          <IconBtn @click="deleteData(item)">
              <VIcon icon="tabler-trash" />
              <v-tooltip
                      activator="parent"
                      location="bottom"
              >刪除</v-tooltip>
          </IconBtn>
      </template>

      <!-- pagination -->
      <template #bottom>
        <TablePagination
                v-model:page="currentPage"
                v-model:size="size"
                :items-per-page="size"
                :total-items="totalDatas"
        />
      </template>
    </VDataTableServer>
    <!-- SECTION -->
  </VCard>
  <!-- 👉 Edit -->
  <EditDsApiTokenVODrawer
          v-model:isDrawerOpen="isEditDataDrawerVisible"
          :dsApiTokenVO-data="voData"
          :is-new="isNewData"
          :is-copy="isCopyData"
          @create-data="addNewData"
          @update-data="updateData"
  />

</template>
